// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';
import 'myWorld/uiComponents/dialog';

myw.CoordinatesDialog = myw.Dialog.extend({
    id: 'coordinates-dialog',

    initialize(owner, options) {
        this.owner = owner;
        this.app = owner.app;
        this.system = this.app.system;
        this.latLngs = options.latLngs;
        myw.Dialog.prototype.initialize.call(this, owner, options);
        this.renderDialog();
    },

    //Open dialog to add to geometry
    renderDialog() {
        if (!this.addObjectDialog) {
            this.$el
                .dialog({
                    modal: false,
                    autoOpen: false,
                    width: '490px',
                    position: { my: 'right-100', at: 'top+300', of: window },
                    title: this.msg('title'),
                    closeText: this.msg('close_tooltip'),
                    buttons: {
                        Close: {
                            text: this.msg('close_btn'),
                            class: 'right',
                            click: () => {
                                this.close();
                            }
                        }
                    },
                    open(event, ui) {
                        $(':focus', this).blur();
                    },
                    close: () => {
                        this.close();
                    }
                })
                .dialog('widget')
                .find('.ui-dialog-buttonset');
            this.messageContainer = $('<div class="message-container"></div>').appendTo(
                this.$el.dialog('widget').find('.ui-dialog-buttonset')
            );
        }
    },

    render(latLngs = null) {
        this.form = new myw.CoordinatesForm({
            feature: this.owner.currentFeature,
            owner: this,
            coords: latLngs || this.latLngs,
            onChange: this.onChange
        });
        this.$el.html(this.form.$el);
    },

    /*
     * Shows the bookmark window.
     */
    show() {
        this.render();
        this.$el.dialog('open');
    },

    close() {
        this.$el.dialog('destroy').remove();
        this.owner.coordinatesDialog = null;
    },

    onInputChange() {
        const values = this.form.getValues();
        const latLngs = this.parseForm(values);
        try {
            this.owner.setLatLngs(latLngs);
            if (this.owner.geomType == 'LineString') this.owner.addSelectedToLastMarker();
        } catch (e) {
            console.log(e);
        }
        if (this.owner.geomType == 'LineString' || this.owner.geomType == 'Point') {
            this.form.coords = latLngs;
        } else if (this.owner.geomType == 'Polygon') {
            this.form.coords = [latLngs];
        }
    },

    //Transform data back into what is expected from feature
    parseForm(values) {
        let latLngs = [];
        const columns = ['lat', 'lng'];
        const rows = Object.keys(values).length / 2;
        for (let i = 0; i < rows; i++) {
            const temp = {};
            columns.forEach(col => {
                const val = Number.parseFloat(values[col + '_' + i]);
                if (!val && val !== 0) return; // Need to keep 0
                temp[col] = val;
            });
            if (Object.keys(temp).length == 2) latLngs.push(temp);
        }
        if (this.owner.geomType == 'Point') latLngs = latLngs[0];
        if (this.owner.geomType == 'LineString') latLngs = this.removeDuplicates(latLngs); //Cannot allow duplicate latLngs if Linetring

        return latLngs;
    },

    removeDuplicates(arr) {
        const result = [];
        const duplicatesIndices = [];

        // Loop through each item in the original array
        arr.forEach((current, index) => {
            if (duplicatesIndices.includes(index)) return;

            result.push(current);

            // Loop through each other item on array after the current one
            for (let comparisonIndex = index + 1; comparisonIndex < arr.length; comparisonIndex++) {
                const comparison = arr[comparisonIndex];
                const currentKeys = Object.keys(current);
                const comparisonKeys = Object.keys(comparison);

                // Check number of keys in objects
                if (currentKeys.length !== comparisonKeys.length) continue;

                // Check key names
                const currentKeysString = currentKeys
                    .sort()
                    .join('')
                    .toLowerCase();
                const comparisonKeysString = comparisonKeys
                    .sort()
                    .join('')
                    .toLowerCase();
                if (currentKeysString !== comparisonKeysString) continue;

                // Check values
                let valuesEqual = true;
                for (let i = 0; i < currentKeys.length; i++) {
                    const key = currentKeys[i];
                    if (current[key] !== comparison[key]) {
                        valuesEqual = false;
                        break;
                    }
                }
                if (valuesEqual) duplicatesIndices.push(comparisonIndex);
            } // end for loop
        }); // end arr.forEach()

        return result;
    }
});

export default myw.VertexDialog;

myw.CoordinatesForm = myw.Form.extend({
    messageGroup: 'GeomDrawMode',
    initialize(options) {
        this.feature = options.feature;
        this.owner = options.owner;
        this.coords = options.coords;

        const schema = {
            messageGroup: 'GeomDrawMode',
            onChange: options.onChange
        };
        schema.rows = this.getRows();

        myw.Form.prototype.initialize.call(this, schema);
    },

    getRows() {
        const rows = [];
        let coords = this.coords;
        if (this.owner.owner.geomType == 'Point') coords = [coords];
        else if (this.owner.owner.geomType == 'Polygon') coords = coords[0];

        coords.forEach((coord, index) => {
            const row = {
                components: [
                    new myw.Label({
                        label: `<strong>${index + 1}:</strong>`
                    }),
                    new myw.Input({
                        name: `lat_${index}`,
                        type: 'number',
                        value: coord['lat'],
                        onChange: () => this.owner.onInputChange(),
                        step: 0.0001
                    }),
                    new myw.Input({
                        name: `lng_${index}`,
                        type: 'number',
                        value: coord['lng'],
                        onChange: () => this.owner.onInputChange(),
                        step: 0.0001
                    })
                ]
            };
            rows.push(row);
        });
        const buttonRow = {
            components: [
                new myw.Button({
                    text: this.msg('add_row'),
                    cssClass: 'ui-button',
                    onClick: this.addRow.bind(this),
                    visible: this.owner.owner.geomType == 'Point' ? false : true
                })
            ]
        };
        rows.push(buttonRow);
        return rows;
    },

    addRow() {
        // Add row respecting different ways geometries are configured
        if (this.owner.owner.geomType == 'LineString') {
            //Add new row only if previous end coords are null
            if (
                this.coords[this.coords.length - 1].lat !== null &&
                this.coords[this.coords.length - 1].lng !== null
            )
                this.coords.push({ lat: null, lng: null });
        } else if (this.owner.owner.geomType == 'Polygon') {
            if (
                this.coords[0][this.coords[0].length - 1].lat !== null &&
                this.coords[0][this.coords[0].length - 1].lng !== null
            )
                this.coords[0].push({ lat: null, lng: null });
        }

        this.owner.render(this.coords);
    }
});
